
import { defineComponent, onMounted, reactive } from 'vue'

// @components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewLimit from '@/common/new-components/NewLimit/index.vue'
import NewPagination from '@/common/new-components/NewPagination/index.vue'
import NewTable from '@/common/new-components/NewTable/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

import CostStandardsFilters from '@/modules/TMSModule/components/CostStandardsFilters/index.vue'
import CostStandardExcel from '@/modules/TMSModule/components/CostStandardExcel/index.vue'
import CostStandardsActions from '@/modules/TMSModule/components/CostStandardsActions/index.vue'

// @types
import { CostStandards, GetCostStandardsParams } from '@/new-services/types/tms'

// @new-services
import tmsAPI from '@/new-services/tms.service'

// @composable
import useActions from '@/common/composable/useActions'

const TABLE_COLUMNS = [
    {
        key: 'direction',
        name: 'Направление',
    },
    {
        key: 'invoiceType',
        name: 'Тип перевозки',
    },
    {
        key: 'capacities[0]',
        name: 'Газель',
    },
    {
        key: 'capacities[1]',
        name: '3 - тонник',
    },
    {
        key: 'capacities[2]',
        name: '5 - тонник',
    },
    {
        key: 'capacities[3]',
        name: '10 - тонник',
    },
    {
        key: 'capacities[4]',
        name: '20 - тонник',
    },
    {
        key: 'cost_per_weight',
        name: 'ТГ/КГ',
    },
    {
        key: 'actions',
        name: '',
    },
]

export default defineComponent({
    components: {
        PageTitle,
        NewButton,
        CostStandardsFilters,
        CostStandardsActions,
        NewLimit,
        NewPagination,
        NewTable,
        Loader,
        CostStandardExcel,
    },
    setup() {
        const { actions_state, startCreate, startUpdate, closeActions } =
            useActions<CostStandards>()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            is_excel: false,
            list: [] as CostStandards[],
            filters: {
                limit: 50,
                current_page: 1,
                total_pages: 1,
                total_items: 1,
                //
                fromCityId: null as number | null,
                toCityId: null as number | null,
                invoiceType: null as number | null,
                transitCityIds: [] as number[],
            },
        })

        const loadCostStandards = async () => {
            try {
                state.is_loading = true

                const params: GetCostStandardsParams = {
                    page: state.filters.current_page,
                    limit: state.filters.limit,
                    //
                    fromCityId: state.filters.fromCityId,
                    toCityId: state.filters.toCityId,
                    invoiceType: state.filters.invoiceType,
                    transitCityIds: state.filters.transitCityIds,
                }

                const response = await tmsAPI.getCostStandards(params)
                state.list = response.data.data

                if (response.data.meta) {
                    state.filters.total_items = response.data.meta.total
                    state.filters.total_pages = response.data.meta.last_page
                }

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const onFiltersChanged = (filters: GetCostStandardsParams) => {
            state.filters.fromCityId = filters.fromCityId as number | null
            state.filters.toCityId = filters.toCityId as number | null
            state.filters.transitCityIds = filters.transitCityIds as number[]
            state.filters.invoiceType = filters.invoiceType as number | null

            state.filters.current_page = 1

            loadCostStandards()
        }

        const onFiltersReset = () => {
            state.filters.fromCityId = null
            state.filters.toCityId = null
            state.filters.invoiceType = null
            state.filters.transitCityIds = []

            state.filters.current_page = 1

            loadCostStandards()
        }

        const onLimitChange = (new_limit: number) => {
            state.filters.limit = new_limit
            loadCostStandards()
        }

        const onChangePage = (new_page: number) => {
            state.filters.current_page = new_page
            loadCostStandards()
        }

        onMounted(loadCostStandards)

        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '0 ₸'
        }

        const onCostStandardsCreated = () => {
            closeActions()
            loadCostStandards()
        }

        const openExcel = () => {
            state.is_excel = true
        }

        const closeExcel = () => {
            state.is_excel = false
        }

        return {
            actions_state,
            startCreate,
            startUpdate,
            closeActions,
            TABLE_COLUMNS,
            state,
            onFiltersChanged,
            onFiltersReset,
            onLimitChange,
            onChangePage,
            loadCostStandards,
            formatAmount,
            onCostStandardsCreated,
            openExcel,
            closeExcel,
        }
    },
})
